import { Skeleton } from '@frontend-workspace/react-shared-lib';

export function CourseReportSkeleton() {
  return (<>
    <div className='d-flex justify-content-end'>
      <Skeleton animation="wave" width={150} height={50} />
    </div>
    <Skeleton variant="rectangular" animation="wave" width='100%' height={650} />
  </>);
}

export default CourseReportSkeleton;